import {
  Card,
  CardContent,
  CardMedia,
  Link as MuiLink,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableRowProps,
} from "@mui/material";
import React, {useState} from "react";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";
import {HandResultItem, SUGGESTION_PATTERN_LABELS, SUGGESTION_PATTERNS} from "../../../../types/pj1dbApiHandling";
import {FingertipDetailDialog} from "../details/FingertipDetailDialog";
import {HandDetailDialog} from "../details/HandDetailDialog";
import {HandDocument} from "../../../equipmentdb/types/pj1dbApiHand";
import {FingertipDocument} from "../../../equipmentdb/types/pj1dbApiFingertip";

export interface SelectedItem {
  result: HandResultItem;
  hand: HandDocument;
  fingertip?: FingertipDocument;
}

export interface HandListItemProps {
  item: HandResultItem;
  hand: HandDocument;
  // eslint-disable-next-line react/require-default-props
  fingertip?: FingertipDocument;
  onSelect: (hand: SelectedItem) => void;
}


export default function HandListItem(props: HandListItemProps) {
  const [openHandDetail, setOpenHandDetail] = useState(false);
  const [openFingertipDetail, setOpenFingertipDetail] = useState(false);
  const mountPattern = "mountPattern" in props.item ? props.item.mountPattern : undefined;

  return (
    <>
      <HandDetailDialog
        open={openHandDetail}
        onClose={() => setOpenHandDetail(false)}
        handId={props.hand.attr.handId}
        mountPattern={mountPattern}
        fingertipId={props.fingertip?.attr.fingertipId}
      />
      {props.fingertip && props.fingertip.attr.fingertipInfo.name
        && props.item.suggestionPattern !== SUGGESTION_PATTERNS.HAND_PLUS_VIRTUAL_FINGERTIP && (
          <FingertipDetailDialog
            open={openFingertipDetail}
            onClose={() => setOpenFingertipDetail(false)}
            fingertipId={props.fingertip.attr.fingertipId}
            mountPattern={mountPattern}
          />
        )}
      <Card key={props.hand.attr.handId} sx={{width: 240, height: 'fit-content'}}>
        <Stack gap={2}>
          <CardMedia
            component="img"
            height="145"
            image={props.hand.url?.image[0]}
            alt={props.hand.attr.handInfo.name}
            sx={{objectFit: "scale-down"}}
            onClick={() => setOpenHandDetail(true)}
          />
          <CardContent sx={{py: 0, px: 1, m: 0}}>
            <Stack gap={3}>
              <TableContainer component={Paper} sx={{maxWidth: "100%"}}>
                <Table size="small">
                  <TableHead sx={{bgcolor: "#EEE"}}>
                    <TableRow>
                      <TableCell align='center' sx={{px: 1, py: 0.5}}>指標</TableCell>
                      <TableCell align='center' sx={{px: 1, py: 0.5}}>属性値</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TRow label='ハンド型' value={SUGGESTION_PATTERN_LABELS[props.item.suggestionPattern]}/>
                    <TRow label='ハンド製品名' value={(
                      <MuiLink component='button' color='info' onClick={() => setOpenHandDetail(true)}>
                        {props.hand.attr.handInfo.name}
                      </MuiLink>
                    )}
                    />
                    <TRow
                      label='爪製品名'
                      value={
                        props.fingertip?.attr.fingertipInfo.name
                        && props.item.suggestionPattern !== SUGGESTION_PATTERNS.HAND_PLUS_VIRTUAL_FINGERTIP ?
                          (
                            <MuiLink component='button' color='info' onClick={() => setOpenFingertipDetail(true)}>
                              {props.fingertip.attr.fingertipInfo.name}
                            </MuiLink>
                          ) : 'なし'}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
              <Pjdb1Button
                label='接続情報を確認'
                onClick={() => props.onSelect({
                  result: props.item,
                  hand: props.hand,
                  fingertip: props.fingertip,
                })}
                variant='contained'
                color='info'
              />
            </Stack>
          </CardContent>
        </Stack>
      </Card>
    </>
  )
}

interface TRowProps extends TableRowProps {
  label: string,
  value: React.ReactNode,
}

function TRow({label, value, ...props}: TRowProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <TableRow {...props} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
      <TableCell align='center' sx={{px: 1, py: 0.5, textWrap: 'nowrap'}}>{label}</TableCell>
      <TableCell align='center' sx={{px: 1, py: 0.5, textWrap: 'nowrap'}}>{value}</TableCell>
    </TableRow>
  )
}
